<template>
  <div class="ca-manage">
    <action-bar>
      <btn-style :btn-list="btnList" class="btn-box"></btn-style>
    </action-bar>
    <common-bg-plate>
      <normal-table :table-col="tableCol" :table-data="caList" :operator="operator" :operate-col="operatorCol"
        :show-edit="showEdit" :paging="caPaging" @pagination="handleSizeOrPageChange">
      </normal-table>
    </common-bg-plate>
    <init-root ref="initRoot" @update:list="getList()"></init-root>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import initRoot from './components/initRoot.vue'
import auth from '@/auth'
export default {
  name: 'Camanage',
  components: {
    initRoot
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '添加CA服务',
          click: () => {
            return this.initRoot()
          },
          icon: 'icon-add',
          auth: auth.camanage.addCA
        }
      ],
      // 设置table的列
      tableCol: [
        {
          prop: 'Name',
          label: '名称',
          minWidth: 158
        },
        {
          prop: 'Country',
          label: '国家',
          minWidth: 132
        },
        {
          prop: 'Province',
          label: '省份',
          minWidth: 154
        },
        {
          prop: 'Locality',
          label: '地区',
          minWidth: 154
        },
        {
          prop: 'Addr',
          label: '地址',
          minWidth: 190
        },
        {
          prop: 'Username',
          label: '用户名',
          minWidth: 130
        },
        {
          prop: 'CreatedTime',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row.CreatedTime)
          },
          minWidth: 208
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '删除',
          click: (row, col, cellValue) => {
            this.deleteCaFn(row)
          },
          showText: true,
          icon: 'icon-cancel',
          class: 'operate-remove operate-danger',
          formatter: (row) => {
            if (this.$utils.hasAuth(this.$store, auth.camanage.deleteCA)) {
              return true;
            } else {
              this.showEdit = false
              return false;
            }
          }
        }
      ],
      operatorCol: {
        minWidth: 74
      },
      // 是否显示操作标头
      showEdit: true
    }
  },
  computed: {
    ...mapState({
      caList: state => state.camanage.ca_list,
      caPaging: state => state.camanage.ca_paging
    })
  },
  watch: {
    '$store.state.home.chainCid': {
      deep: true,
      handler() {
        this.getList()
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getCaLists', 'deleteCa']),
    getList(limit = 10, offset = 0) {
      let params = {
        offset,
        limit,
        certType: 3,
        chainId: this.$store.state.home.chainCid
      }
      this.getCaLists(params)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    formatTime(time) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', time)
    },
    initRoot() {
      this.$refs.initRoot.handleOpen()
    },
    deleteCaFn(row) {
      this.$confirm('此操作将永久删除该CA服务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteCa({ params: { id: row.Id } }).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getList(10, this.caPaging.offset)
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
